module.exports = __webpack_public_path__ + "img/loginMiddle.07d9785b.png";